if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    module.exports = require('./index.dev');
} else {
    module.exports = require('./index.prod');
}